import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const fields = {
  _id: '',
  description: '',
  assessorCodes: '',
  adjType: '',
  supplement: '',
};

export const taxAdjTypesShared = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadtaxAdjTypesSharedRecords({ commit, dispatch },
      { baseCrudKey, criteria, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxAdjTypes($criteria: taxAdjTypesCriteriaType) {
            taxAdjTypes(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxAdjTypes } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxAdjTypes) : taxAdjTypes;
          commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
    },
    async upserttaxAdjTypes({ dispatch, rootGetters, commit },
      { item, baseCrudKey, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttaxAdjTypes($item: taxAdjTypesInputType!)  {
            upserttaxAdjTypes(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxUnit = results.data.upserttaxAdjTypes;
        const processedTransData = postProcessTrans
          ? postProcessTrans(newTaxUnit) : newTaxUnit;
        const newList = mergeByIdNewAtTop(taxData || [], processedTransData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the adj types List', { root: true });
      }
    },
    async deleteTaxAdjType({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletetaxAdjType ($id: ID!)  {
            deletetaxAdjType(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletetaxAdjType._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Adj List', { root: true });
      }
    },
  },
};

export default taxAdjTypesShared;
